// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video_wrapper__SeVKe","container":"Video_container__bgAUF","col":"Video_col__McdCg","heading":"Video_heading__8qdWO"};